import { createContext, useContext, type PropsWithChildren } from "react";

import { FeatureFlags, useFeatureFlagsQuery } from "hooks/api/use-feature-flags";

export type FeatureFlagsType = FeatureFlags;

const FeatureFlagContext = createContext<FeatureFlagsType | undefined>(undefined);

export const useFeatureFlags = (): FeatureFlagsType => {
  const flags = useContext(FeatureFlagContext);
  if (!flags) {
    throw new Error("useFeatureFlags must be used within a FeatureFlagProvider");
  }
  return flags;
};

export const FeatureFlagProvider = ({ children }: PropsWithChildren) => {
  const { data: featureFlags = {}, isLoading } = useFeatureFlagsQuery();

  if (isLoading) return null;

  return <FeatureFlagContext.Provider value={featureFlags}>{children}</FeatureFlagContext.Provider>;
};

export const useFeatureFlag = (flagName: string): boolean => {
  const flags = useContext(FeatureFlagContext);
  if (!flags) {
    throw new Error("useFeatureFlag must be used within a FeatureFlagProvider");
  }
  return flags[flagName] ?? false;
};
